import styled, { css } from "styled-components";
import { Sizes } from "../../dropdown";

const getTriggerButtonHeight = (size: Sizes) => {
  return {
    [Sizes.Lg]: "60px",
    [Sizes.Md]: "48px",
    [Sizes.Sm]: "40px",
  }[size ?? Sizes.Md];
};

export interface TriggerButtonProps {
  error: boolean;
  size: Sizes;
  disabled: boolean;
}

export const StyledTriggerButton = styled.button<TriggerButtonProps>`
  width: 100%;
  height: ${(props) => getTriggerButtonHeight(props.size)};

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xs5};

  padding-left: ${({ theme }) => theme.spacings.xs3};
  padding-right: 10px;
  border: ${({ theme }) =>
    `${theme.borders.width.xs2} solid ${theme.colors.neutral[90]}`};
  border-radius: ${({ theme }) => theme.borders.radius.m};

  transition: border-color 0.3s;

  &:hover:not(:disabled) {
    border-color: ${({ error, theme }) =>
      error ? theme.colors.feedback.error[50] : theme.colors.neutral[50]};
    box-shadow: 0 0 0 1px
      ${({ error, theme }) =>
        error ? theme.colors.feedback.error[50] : theme.colors.neutral[50]};
  }

  &:active:not(:disabled),
  &:focus {
    border-color: ${({ error, theme }) =>
      error ? theme.colors.feedback.error[50] : theme.colors.secondary[70]};
    box-shadow: 0 0 0 1px
      ${({ error, theme }) =>
        error ? theme.colors.feedback.error[50] : theme.colors.secondary[70]};

    & svg {
      color: ${({ error, theme }) =>
        error ? theme.colors.feedback.error[50] : theme.colors.secondary[70]};
      stroke: currentColor;
    }
  }

  ${({ error, theme }) =>
    error &&
    css`
      background-color: ${theme.colors.feedback.error[90]};
      border-color: ${theme.colors.feedback.error[50]};
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.feedback.error[50]};

      & svg {
        color: ${theme.colors.feedback.error[50]};
        stroke: currentColor;
      }
    `}

  && {
    ${({ disabled, theme }) =>
      disabled &&
      css`
        background-color: ${theme.colors.neutral[95]};
        border: ${({ theme }) =>
          `${theme.borders.width.xs2} solid ${theme.colors.neutral[80]}`};

        & svg {
          color: ${theme.colors.neutral[70]};
          stroke: currentColor;
        }

        & p {
          color: ${theme.colors.neutral[70]};
        }

        cursor: not-allowed;
      `}
  }
`;
